import React from 'react'
import { useDispatch } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { ScrollableUserList } from 'components/UI'

const PunchStartBreakModal = ({ hasRead }) => {
  const dispatch = useDispatch()
  return (
    <BaseModal hideButtons title={`manager.bulletins.READ_BY`}>
      <ScrollableUserList usersIds={hasRead} />
      <div className="mt-2">
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default PunchStartBreakModal
